import { WidgetConfig } from '../../types/config/config.types';
import { conditionalField } from '../object';
import { notNullish } from '../../../shared/lib/utils';

import { useJourneyId } from './journey_id';
import { useExternalTrs } from './external_trs';

export type WidgetConfigWithDynamicParameters = WidgetConfig & {
  globals: { hiddens: { journey_id?: string; trs?: string } };
};

/**
 * Динамические параметры - это параметры, которые могут поменяться в рантайме,
 * например, по запросу от других микрофронтендов. Здесь мы просто берем конфиг виджета
 * и добиваем его такими параметрами
 * @param widgetId
 * @param config
 */
export const useConfigWithDynamicParameters = (
  widgetId: string,
  config: WidgetConfig,
): WidgetConfigWithDynamicParameters => {
  const journeyId = useJourneyId(widgetId);
  const externalTrs = useExternalTrs(config.globals.hiddens.trs);
  const hiddens = { ...config.globals.hiddens };

  if (hiddens.trs === 'trs') {
    delete hiddens.trs;
  }

  return {
    ...config,
    globals: {
      ...config.globals,
      hiddens: {
        ...hiddens,
        ...conditionalField('journey_id', journeyId, notNullish(journeyId)),
        ...conditionalField('trs', externalTrs, !hiddens.trs && notNullish(externalTrs)),
      },
    },
  };
};
